export const FACTSHEET_ENGLISH = {
  "datox.factsheet.title": "Factsheet",
  "datox.factsheet.description": "Turn portfolio source files into a factsheet report and an editable dashboard with the Factsheet agent skill.",
  "datox.factsheet.outputs": "HTML factsheet reports and editable dashboards, backed by saved extraction and output tables.",
  "datox.factsheet.configure": "Set up a factsheet workflow",
  "datox.factsheet.step.workspace": "Project and period",
  "datox.factsheet.step.files": "Upload source files",
  "datox.factsheet.step.report": "Extract, calculate and report",
  "datox.factsheet.step.dashboard": "Create editable dashboard",
  "datox.factsheet.project": "Project",
  "datox.factsheet.projectName": "Project name",
  "datox.factsheet.projectPlaceholder": "For example, Portfolio reporting",
  "datox.factsheet.newProject": "Create a new project",
  "datox.factsheet.period": "Reporting period",
  "datox.factsheet.newPeriod": "Create a new period",
  "datox.factsheet.periodName": "New period name",
  "datox.factsheet.periodPlaceholder": "For example, Q2, 2026",
  "datox.factsheet.files": "Factsheet source files",
  "datox.factsheet.filesHint": "Upload positions or holdings, security reference and benchmark data. Include NAV, returns or cash-flow history when available. The agent will identify the fields and ask about any essential gaps.",
  "datox.factsheet.chooseFiles": "Choose files",
  "datox.factsheet.existingFiles": "Or select files already uploaded to this period",
  "datox.factsheet.removeFile": "Remove {{name}}",
  "datox.factsheet.uploaded": "Uploaded",
  "datox.factsheet.pending": "Ready to upload",
  "datox.factsheet.generate": "Generate factsheet",
  "datox.factsheet.generating": "Generating…",
  "datox.factsheet.retry": "Retry generation",
  "datox.factsheet.checkResults": "Check saved results",
  "datox.factsheet.refresh": "Refresh sources",
  "datox.factsheet.openWorkflow": "Open workflow",
  "datox.factsheet.openChat": "Continue with agent",
  "datox.factsheet.openDashboards": "Open dashboards",
  "datox.factsheet.openReport": "Open report",
  "datox.factsheet.ready": "Your factsheet reports and dashboards have been saved.",
  "datox.factsheet.needsInput": "The agent needs more information, or not all outputs have been saved yet. Continue in the agent chat, then check the saved results.",
  "datox.factsheet.error": "The factsheet workflow could not finish. Uploaded files and completed results are retained. Retry, or continue with the agent.",
  "datox.factsheet.loadError": "Could not load projects, periods or files. Refresh before continuing.",
  "datox.factsheet.preparing": "Preparing the project, period and uploaded files…",
  "datox.factsheet.uploading": "Uploading the selected source files to the reporting period…",
  "datox.factsheet.reporting": "The agent is reviewing the files, saving extracted data and generating factsheet reports…",
  "datox.factsheet.dashboarding": "The agent is building editable dashboards from the saved output tables…",
  "datox.factsheet.scopeHint": "Results are saved in the selected project and period. Use Workflow to inspect Files, Categories, Extractions, Transformations and Output.",
  "datox.factsheet.sessionTitle": "Factsheet · {{period}}",
} as const
